import { getCurrentLanguage } from "utils/src/getCurrentLanguage";
import { apiClient } from "../../../../apps/crossword-maker/src/shared/apiClient";
import { PaginationResponseData } from "../../../../apps/crossword-maker/src/shared/types/RestApi.types";
import {
	ICrosswordBookApiRequestData,
	ICrosswordBookApiResponse,
	ICrosswordBookWordEntity,
} from "./CrosswordBook.api.types";

export type TGetManyWords = (
	data?: ICrosswordBookApiRequestData,
) => Promise<ICrosswordBookApiResponse>;

export const getManyWords: TGetManyWords = async (data) => {
	const language = getCurrentLanguage();
	const response = await apiClient().get<PaginationResponseData<ICrosswordBookWordEntity>>(
		`/rest/${language}/crossword-book/words`,
		{ params: { ...data } },
	);

	return {
		items: response.data.items,
		paginationInfo: response.data.paginationInfo,
	};
};
